{
  "block_page_editor": {
    "add_comment": "Add comment",
    "untitled_placeholder": "Untitled"
  },
  "block_page_list_menu_options": {
    "page_options_aria_label": "page options",
    "long_menu_aria_controls": "long-menu",
    "delete_page_aria_label": "delete page"
  },
  "block_page_list": {
    "add_page_aria_label": "add page",
    "add_page": "Add Page",
    "page_names_aria_label": "page names",
    "untitled_page": "Untitled Page"
  },
  "block_page_ui": {
    "loading_page_aria_label": "loading page",
    "error_prefix": "Error: "
  },
  "task_with_section_block": {
    "add_task": "Add Task",
    "task_name_empty_error": "Task name cannot be empty",
    "add_task_error": "An unexpected error occurred while adding the task.",
    "section_placeholder": "Type task section or select existing section",
    "create_section_error": "An unexpected error occurred while creating the section.",
    "create_new_task_aria": "create new task",
    "add_task_to_section_aria": "Add a new task to section",
    "toggle_dropdown_aria": "Toggle section dropdown",
    "section_title_aria": "section-title"
  },
  "block_note_emoji_picker": {
    "add_emoji": "Add Emoji"
  },
  "block_provider_editor": {
    "syncing": "Syncing..."
  },
  "remove_page": {
    "confirm_delete_title": "Are you sure you want to delete this page?",
    "confirm_delete_content": "Click the confirm button to delete the page."
  },
  "images_block": {
    "insert_image_url": "Insert Image URL",
    "image_url": "Image URL",
    "image_url_placeholder": "Enter image URL",
    "image_url_required": "Image URL is required.",
    "image_caption": "Image Caption",
    "image_caption_placeholder": "Enter image caption",
    "insert_image": "Insert Image"
  },
  "contact_card_block": {
    "contact_required": "Contact is required",
    "contact": "Contact",
    "add_contact_card": "Add contact card",
    "add_contact_card_placeholder": "Add contact card by name or email"
  },
  "checklist_items_block": {
    "title": "Checklist Item",
    "subtext": "Insert a checklist item row"
  },
  "checklists_block": {
    "title": "Insert Checklists Block",
    "subtext": "Insert a checklist block",
    "checklist_title_placeholder": "Enter the title of the checklist",
    "item_label_placeholder": "Enter label"
  },
  "linkable_tab_block": {
    "title": "Link To Tab",
    "subtext": "Insert a link to a workspace tab",
    "select_tab_prompt": "Select tab to link to"
  },
  "company_card_block": {
    "title": "Company Card",
    "subtext": "Insert a company card",
    "company_required": "Company is required",
    "company_label": "Company",
    "add_company_card_label": "Add company card",
    "add_company_card_placeholder": "Add company card"
  },
  "documents_upload_block": {
    "modal_header": "Add Document",
    "document_name_label": "Document Name",
    "document_url_label": "Document URL",
    "or": "or",
    "drag_drop_text": "Drag a single document here or click to upload",
    "url_required_error": "Please enter an url or upload the document",
    "file_size_error": "Max file size: 50MB, current file size: {{size}}MB",
    "unsupported_file_error": "Unsupported file type: {{type}}"
  },
  "campaign_analysis_block": {
    "campaign_required": "Campaign is required",
    "campaign_label": "Campaign",
    "select_campaign_placeholder": "Select a campaign",
    "no_campaigns_message": "Please create a campaign in this workspace before proceeeding.",
    "loading_campaign": "Loading Campaign"
  },
  "task_list_block": {
    "table_headers": {
      "title": "Title",
      "delegated_to": "Delegated to",
      "due_date": "Due date",
      "status": "Status"
    },
    "no_tasks_found": "No tasks found."
  },
  "youtube_block": {
    "modal_header": "Insert YouTube Video",
    "url_label": "YouTube URL",
    "url_placeholder": "Enter YouTube URL",
    "invalid_url_error": "Please enter a valid YouTube URL.",
    "insert_button": "Insert Video",
    "video_player_title": "Nexl YouTube video player"
  },
  "rollup_field_block": {
    "title": "Rollup Fields",
    "open_modal_aria_label": "Open rollup fields modal",
    "insert": {
      "title": "Rollup Field",
      "subtext": "Show rollup summaries of values from related lists."
    },
    "table": {
      "columns": {
        "rollup_name": "Rollup Name",
        "source": "Source",
        "value": "Value"
      },
      "opportunities": "Opportunities"
    }
  }
}
